import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MainLayout from "../../layouts/MainLayout";
import DataTable from "../../components/DataTable";
import Alert from "../../components/Alert";
import { listStaff, deleteStaff } from "../../api/staffApi";
import "../Users/UsersPage.css";

export default function StaffListPage() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const load = () => {
    setLoading(true);
    listStaff()
      .then(setStaff)
      .catch(() => setError("Failed to load staff."))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const handleDelete = async (member) => {
    if (!window.confirm(`Delete staff "${member.staffName}" (${member.customStaffId})?`)) {
      return;
    }
    setError("");
    try {
      await deleteStaff(member.staffId);
      setSuccess("Staff deleted.");
      setStaff((prev) => prev.filter((s) => s.staffId !== member.staffId));
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to delete staff.");
    }
  };

  const columns = [
    { key: "customStaffId", label: "ID" },
    { key: "staffName", label: "Name" },
    { key: "designationName", label: "Designation" },
    { key: "mobileNumber", label: "Mobile" },
    { key: "staffStatus", label: "Status", render: (row) => (row.staffStatus === 1 ? "Active" : "Inactive") },
  ];

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Staff</h1>
        <Link className="btn-primary" to="/staff/new">
          + Add Staff
        </Link>
      </div>

      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <DataTable
          columns={columns}
          rows={staff}
          actions={(member) => (
            <>
              <Link className="btn-link" to={`/staff/${member.staffId}/edit`}>
                Edit
              </Link>
              <button type="button" className="btn-link danger" onClick={() => handleDelete(member)}>
                Delete
              </button>
            </>
          )}
        />
      )}
    </MainLayout>
  );
}
